import '@/global.scss'
import { definePageConfig, defineRunApp } from './type-defines';
import { Link, NavLink, Outlet, useParams, useSearchParams, useLocation, useData, useConfig, useNavigate, useNavigation, useRevalidator } from '@ice/runtime/router';
import { defineAppConfig, useAppData, history, useActive, KeepAliveOutlet, useMounted, ClientOnly, withSuspense, useSuspenseData, usePublicAppContext as useAppContext, Await, usePageLifecycle, unstable_useDocumentData, dynamic } from '@ice/runtime';
import { defineDataLoader, defineServerDataLoader, defineStaticDataLoader } from '@ice/runtime/data-loader';
import * as webModule1 from '@ice/runtime';
import type { MetaType, TitleType, LinksType, ScriptsType, FirstChunkCacheType, DataType, MainType} from '@ice/runtime';
import { useRequest } from '@ice/plugin-request/hooks';
import { request } from '@ice/plugin-request/request';
import { useSpm } from '@ali/ice-plugin-spm/runtime';

let Meta: MetaType;
let Title: TitleType;
let Links: LinksType;
let Scripts: ScriptsType;
let FirstChunkCache: FirstChunkCacheType;
let Data: DataType;
let Main: MainType;
let usePageAssets: any;
if (import.meta.target === 'web') {
  Meta = webModule1.Meta;
  Title = webModule1.Title;
  Links = webModule1.Links;
  Scripts = webModule1.Scripts;
  FirstChunkCache = webModule1.FirstChunkCache;
  Data = webModule1.Data;
  Main = webModule1.Main;
  usePageAssets = webModule1.usePageAssets;
}
      

export {
  definePageConfig,
  defineRunApp,
  Link,
  NavLink,
  Outlet,
  useParams,
  useSearchParams,
  useLocation,
  useData,
  useConfig,
  useNavigate,
  useNavigation,
  useRevalidator,
  defineAppConfig,
  useAppData,
  history,
  useActive,
  KeepAliveOutlet,
  useMounted,
  ClientOnly,
  withSuspense,
  useSuspenseData,
  useAppContext,
  Await,
  usePageLifecycle,
  unstable_useDocumentData,
  dynamic,
  defineDataLoader,
  defineServerDataLoader,
  defineStaticDataLoader,
  useRequest,
  request,
  useSpm,  Meta,
  Title,
  Links,
  Scripts,
  FirstChunkCache,
  Data,
  Main,
  usePageAssets
};

export * from './types';
